import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n";
import App from "@/App";

const container = document.getElementById("root");
const tree = (
  <React.StrictMode>
    <Suspense fallback={
      <div className="min-h-screen bg-black flex items-center justify-center">
        <div className="text-white/50">Loading...</div>
      </div>
    }>
      <App />
    </Suspense>
  </React.StrictMode>
);

// Phase B (WP-2 §2B — Static Snapshot + CSR Reconciliation). When #root contains a prerendered
// snapshot, its <head> carries React-19-native metadata (title / description / canonical) captured
// from the snapshot build. createRoot re-renders the app and re-emits those, which would DUPLICATE
// them. Strip ONLY those prerendered <head> tags before mounting so the re-render yields exactly one
// set. This removes duplicate metadata only — it never touches business content, and the snapshot's
// JSON-LD lives inside #root (replaced by the re-render), so it is not mutated here. Entry-point
// mount logic only — no component / C1A / C1B / registry change.
// WP-3.1 — the same dedup applies to the sitewide search-engine verification metas
// (SiteVerification.jsx, render-time): strip the prerendered copies so the re-render yields one.
if (container.hasChildNodes()) {
  document.head
    .querySelectorAll(
      'title, meta[name="description"], link[rel="canonical"], ' +
        'meta[name="google-site-verification"], meta[name="msvalidate.01"]',
    )
    .forEach((el) => el.remove());
}
ReactDOM.createRoot(container).render(tree);
